import { render, staticRenderFns } from "./button_group.vue?vue&type=template&id=23b7478d&scoped=true&"
import script from "./button_group.vue?vue&type=script&lang=js&"
export * from "./button_group.vue?vue&type=script&lang=js&"
import style0 from "./button_group.vue?vue&type=style&index=0&id=23b7478d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b7478d",
  null
  
)

export default component.exports